export const VIEWER_STEP = [
    'Preparation',
    'Adjustment',
    'Design',
    'Simulation',
];
